import React from 'react';
import classNames from 'classnames';
import SearchBar from '@fiverr-private/search_bar/src/components/SearchBar';
import { getContext, I18n, I18nProvider } from '@fiverr-private/fiverr_context';
import { getSubCategoryUrl, getStoreUrl } from '../../../utils/url';
import SafeComponent from '../../shared/SafeComponent';
import { popularSearches, reportBi, BI_TYPE_TAGS } from './config';

import './style.scss';

const TAG_SOURCE = 'hplo_search_tag';

const getTagPath = (tag, pos) => {
    switch (tag.type) {
        case 'subcategory':
            const subCatParams = { source: TAG_SOURCE, pos, name: tag.subCategorySlug };
            const { categorySlug, subCategorySlug } = tag;
            return getSubCategoryUrl({ categorySlug, subCategorySlug, params: subCatParams });
        case 'store':
            const storeParams = { source: TAG_SOURCE, pos, name: tag.storeSlug };
            return getStoreUrl(tag.storeSlug, storeParams);
        default:
            return '';
    }
};

const Header = () => {
    const { queryParameters = {} } = getContext();
    const { default_font } = queryParameters;
    const h1ClassName = classNames({ 'font-domaine': default_font !== '1' });

    return (
        <div className="header">
            <h1 className={h1ClassName}>
                <I18n k="logged_out_homepage.hero.title" parseMarkup/>
            </h1>
            <I18nProvider>
                {({ i18n }) => (
                    <SearchBar placeholder={i18n.t('logged_out_homepage.hero.try_mobile_app')}
                        source="main_banner"/>
                )}
            </I18nProvider>
            <div className="popular">
                <I18n k="logged_out_homepage.hero.popular"/>
                <ul>
                    {
                        popularSearches.map((item, index) => {
                            const pos = index + 1;
                            const tagPath = getTagPath(item, pos);

                            return (
                                <li key={item.name}>
                                    <a href={tagPath}
                                        className="text-body-2"
                                        onClick={() => reportBi(BI_TYPE_TAGS, { position: pos, ...item })}>
                                        <I18n k={`logged_out_homepage.hero.${item.name}`}/>
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
};

export { Header };
export default SafeComponent(Header);
